var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-header"},[_c('div',{staticClass:"products__heading"},[_c('div',[_c('div',{staticClass:"mobile-merchant-name"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }